import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import CardFloat from '../Card/CardFloat';
import Heading from '../Heading';
import Link, { LinkProps } from '../Link';

interface PropTypes {
  link?: string;
  float?: React.ReactNode;
  noMargin?: boolean;
  title: string | ReactNode;
}

const HeaderWithFloat: React.FC<PropTypes> = ({ float, link, noMargin, title }) => {
  const Wrapper = link ? Link : React.Fragment;
  const wrapperProps = link
    ? {
        to: link,
      }
    : {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Wrapper {...(wrapperProps as LinkProps)}>
          <Heading>{title}</Heading>
        </Wrapper>
      </Box>
      {float && (
        <Box
          sx={
            noMargin
              ? undefined
              : {
                  marginRight: '-1rem',
                }
          }
        >
          <CardFloat>{float}</CardFloat>
        </Box>
      )}
    </Box>
  );
};

export default HeaderWithFloat;
